<div class="z-0 h-56 w-full lg:h-full border-1 rounded-lg shadow" id="map-thumbnail-{{orderID}}"></div>